import { useState } from 'react';
import { IconButton, Badge, Popover } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsList from './account/inbox/Inbox'; // تأكد أن المسار صحيح

export default function NotificationBell({ unreadCount, notifications, email }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPopover = (event) => setAnchorEl(event.currentTarget);
  const handleClosePopover = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  return (
    <>
      {/* أيقونة الجرس */}
      <IconButton aria-label="notifications" onClick={handleOpenPopover}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      {/* القائمة المنسدلة باستخدام Popover */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{ sx: { width: 400, maxHeight: 500 } }}
      >
        {/* عرض قائمة الإشعارات داخل الـ Popover */}
        <NotificationsList
          email={email}
          notifications={notifications}
          onClose={handleClosePopover} // علشان نقفل القائمة بعد اختيار إشعار
        />
      </Popover>
    </>
  );
}
